/* The compare page's model columns on phones (sections/oricle-compare-columns.liquid): model tabs over one card at a
   time. Desktop shows all three cards and no tabs. Without this script the cards stack and the tab row stays hidden. */
(() => {
  const phone = window.matchMedia('(max-width: 767px)');

  function arm(root) {
    if (root.dataset.oCcArmed) return;
    const list = root.querySelector('[data-o-cc-tabs]');
    const tabs = Array.from(root.querySelectorAll('[data-o-cc-tab]'));
    const cards = Array.from(root.querySelectorAll('[data-o-cc-card]'));
    if (!list || !tabs.length || tabs.length !== cards.length) return;
    root.dataset.oCcArmed = '1';
    let cur = Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));

    const apply = () => {
      const on = phone.matches;
      list.hidden = !on;
      root.classList.toggle('is-tabbed', on);
      tabs.forEach((t, i) => {
        t.setAttribute('aria-selected', i === cur ? 'true' : 'false');
        t.tabIndex = i === cur ? 0 : -1;
      });
      cards.forEach((c, i) => {
        if (on) {
          c.setAttribute('role', 'tabpanel');
          c.setAttribute('aria-labelledby', tabs[i].id);
          c.hidden = i !== cur;
        } else {
          c.removeAttribute('role');
          c.removeAttribute('aria-labelledby');
          c.hidden = false;
        }
      });
    };

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => { cur = i; apply(); });
      t.addEventListener('keydown', (e) => {
        const last = tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = cur === last ? 0 : cur + 1;
        else if (e.key === 'ArrowLeft') next = cur === 0 ? last : cur - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        cur = next;
        apply();
        tabs[cur].focus();
      });
    });
    phone.addEventListener('change', apply);
    apply();
  }

  const init = () => document.querySelectorAll('[data-o-cc]').forEach(arm);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
